export const styles = {
	container: {
		sx: {
			minWidth: '1108px',
			borderRadius: 2,
		},
	},
	mobileContainer: {
		sx: {
			borderRadius: 2,
		},
	},
	content: {
		textAlign: 'center',
	},
	xButton: {
		position: 'absolute',
		right: 0,
		zIndex: 1,
		top: 8,
	},
	mobileXButton: {
		position: 'absolute',
		right: 0,
		top: 8,
	},
	faqTitle: {
		textAlign: 'left',
		fontWeight: 'bold',
		fontSize: '20px',
	},
	question: {
		pageBreakAfter: 'avoid',
		textAlign: 'left',
		fontWeight: 'bold',
	},
	answer: {
		fontSize: '0.875rem',
		textAlign: 'left',
	},
};
